export const EDIT_NOTE = "EDIT_NOTE";
export const SET_NOTE = "SET_NOTE";

export const FETCH_NOTE_LOADING = "FETCH_NOTE_LOADING";
export const FETCH_NOTE_SUCCESS = "FETCH_NOTE_SUCCESS";
export const FETCH_NOTE_FAILED = "FETCH_NOTE_FAILED";

export const CREATE_NOTE_LOADING = "CREATE_NOTE_LOADING";
export const CREATE_NOTE_SUCCESS = "CREATE_NOTE_SUCCESS";
export const CREATE_NOTE_FAILED = "CREATE_NOTE_FAILED";

export const EDIT_NOTE_LOADING = "EDIT_NOTE_LOADING";
export const EDIT_NOTE_SUCCESS = "EDIT_NOTE_SUCCESS";
export const EDIT_NOTE_FAILED = "EDIT_NOTE_FAILED";

export const DELETE_NOTE_LOADING = "DELETE_NOTE_LOADING";
export const DELETE_NOTE_SUCCESS = "DELETE_NOTE_SUCCESS";
export const DELETE_NOTE_FAILED = "DELETE_NOTE_FAILED";
